// src/utils/numberToWordsIndian.js
export const numberToWordsIndian = (num) => {
    const a = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
      'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
      'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen',
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  
    const numToWords = (n, s = '') => {
      let str = '';
      if (n > 19) str += b[Math.floor(n / 10)] + ' ' + a[n % 10];
      else str += a[n];
      if (n !== 0) str += s;
      return str;
    };
  
    if (num === 0) return 'Zero Rupees Only';
  
    let output = '';
    output += numToWords(Math.floor(num / 10000000), ' Crore ');
    output += numToWords(Math.floor((num / 100000) % 100), ' Lakh ');
    output += numToWords(Math.floor((num / 1000) % 100), ' Thousand ');
    output += numToWords(Math.floor((num / 100) % 10), ' Hundred ');
  
    if (num > 100 && num % 100 !== 0) output += 'and ';
    output += numToWords(num % 100, '');
  
    return output.trim() + ' Rupees Only';
  };
  